type RecoveryEnvironment = {
  storage: Pick<Storage, 'getItem' | 'setItem'>
  now: number
  reload: (path: string) => void
}
const KEY = 'pulsewatch.chunk-recovery'

export function recoverNavigation(
  error: unknown,
  path: string,
  environment?: RecoveryEnvironment,
): boolean {
  const message = error instanceof Error ? error.message : String(error)
  if (
    !/Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk .+ failed|error loading dynamically imported module|Unable to preload CSS/i.test(
      message,
    )
  )
    return false
  if (!path.startsWith('/') || path.startsWith('//')) return false
  const context = environment ?? {
    storage: sessionStorage,
    now: Date.now(),
    reload: (target: string) => window.location.assign(target),
  }
  try {
    const previous = Number(context.storage.getItem(KEY) || 0)
    if (previous && context.now - previous < 60_000) return false
    context.storage.setItem(KEY, String(context.now))
  } catch {
    return false
  }
  context.reload(path)
  return true
}
